import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, useApp } from '@pixi/react';
import { useEffect, useRef, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { findPixiObject } from '../../../../../cypress/support/commonPixiTypes';
import { useInstanceId } from '../../../../context/instance/instanceContext';
import { useAppSelector } from '../../../../redux/store';
import { MovingPotDisplay } from './movingPotDisplay';
import { StationaryPotDisplay } from './stationaryPotDisplay';
export const MainOrSidePotContainer = ({ x, y, potIndex, amount, numPots }) => {
    const [potDestinations, setPotDestinations] = useState([]);
    const app = useApp();
    const instanceId = useInstanceId();
    const currentShowdownPotIndex = useAppSelector((state) => state.poker.currentShowdown?.potIndex);
    const currentShowdownStartTimeStampMs = useAppSelector((state) => state.poker.currentShowdown?.startTimeStampMs);
    const bigBlind = useAppSelector((state) => state.poker.bigBlind);
    const showChipsAsBbMultiple = useAppSelector((state) => state.selfData.isShowChipsAsBbMultipleEnabled);
    const destinationSeatIndexes = useAppSelector((state) => {
        if (currentShowdownPotIndex === potIndex) {
            return state.poker.winningSeatIndexes;
        }
    }, shallowEqual);
    const currency = useAppSelector((state) => state.poker.currency);
    const containerRef = useRef(null);
    useEffect(() => {
        if (containerRef.current?.getGlobalPosition &&
            currentShowdownStartTimeStampMs !== undefined &&
            destinationSeatIndexes) {
            const fromPoint = containerRef.current.getGlobalPosition();
            const newPotDestinations = destinationSeatIndexes.map((destinationSeatIndex) => {
                const requiredPixiObjectData = {
                    type: 'player-chips-or-status-container',
                    seatIndex: destinationSeatIndex
                };
                const destPixiObject = findPixiObject(app.stage, requiredPixiObjectData);
                // if destination seat player doesn't exist for some reason, don't try to move the chips at all:
                const toPoint = destPixiObject && 'getGlobalPosition' in destPixiObject ? destPixiObject.getGlobalPosition() : fromPoint;
                return {
                    destinationSeatIndex,
                    deltaX: toPoint.x - fromPoint.x,
                    deltaY: toPoint.y - fromPoint.y,
                    startTimestampMs: currentShowdownStartTimeStampMs
                };
            });
            setPotDestinations(newPotDestinations);
        }
        else {
            setPotDestinations([]);
        }
    }, [app.stage, currentShowdownStartTimeStampMs, destinationSeatIndexes, instanceId]);
    if (currentShowdownPotIndex !== undefined && currentShowdownPotIndex > potIndex) {
        // With a current showdown pot index set, we are in the showdown phase with pot animations happening.
        // If this component's pot index is has already been handled/animated in a previous showdown, don't show it again.
        return null;
    }
    if (!currency) {
        return null;
    }
    return (_jsx(Container, { x: x, y: y, ref: containerRef, children: potDestinations.length ? (potDestinations.map((potDestination, i) => {
            const playerWinAmount = Math.floor(amount / potDestinations.length);
            return (_jsx(MovingPotDisplay, { potIndex: potIndex, potSplitIndex: i, x: 0, y: 0, amount: playerWinAmount, destinationSeatIndex: potDestination.destinationSeatIndex, deltaX: potDestination.deltaX, deltaY: potDestination.deltaY, startTimestampMs: potDestination.startTimestampMs, currency: currency, showChipsAsBbMultiple: showChipsAsBbMultiple, bigBlind: bigBlind }, i));
        })) : (_jsx(StationaryPotDisplay, { currency: currency, potIndex: potIndex, amount: amount, numPots: numPots })) }));
};
